/* Admiral Row cart focus and optional-protection guidance. */
(() => {
  'use strict';
  const script = document.currentScript;

  class RouteGuidance extends HTMLElement {
    connectedCallback() {
      this.mount = this.parentElement.querySelector('[data-route-cart-protection]');
      this.update = () => {
        const widget = this.mount?.querySelector('route-protect-widget');
        this.hidden = !widget || !widget.hasAttribute('quote');
      };
      if (this.mount) {
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.mount, {childList: true, subtree: true, attributes: true, attributeFilter: ['quote', 'status']});
      }
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  if (!customElements.get('ar-route-guidance')) customElements.define('ar-route-guidance', RouteGuidance);

  // Keep the native carrier calculator, but never leave obsolete rates visible.
  class ShippingEstimate extends HTMLElement {
    connectedCallback() {
      this.response = this.querySelector('#wrapper-response');
      this.notice = this.querySelector('[data-ar-estimate-stale]');
      this.requested = false;
      this.stale = false;
      this.invalidate = () => {
        if (!this.requested) return;
        this.stale = true;
        this.response?.replaceChildren();
        if (this.notice) this.notice.hidden = false;
      };
      this.onClick = event => {
        if (!(event.target instanceof Element) || !event.target.closest('.get-rates')) return;
        this.requested = true;
        this.stale = false;
        if (this.notice) this.notice.hidden = true;
      };
      this.addEventListener('input', this.invalidate);
      this.addEventListener('change', this.invalidate);
      this.addEventListener('click', this.onClick, true);
      document.addEventListener('theme:cart:change', this.invalidate);
      this.observer = new MutationObserver(() => {
        if (this.stale && this.response?.hasChildNodes()) this.response.replaceChildren();
      });
      if (this.response) this.observer.observe(this.response, {childList: true, subtree: true});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('input', this.invalidate);
      this.removeEventListener('change', this.invalidate);
      this.removeEventListener('click', this.onClick, true);
      document.removeEventListener('theme:cart:change', this.invalidate);
    }
  }
  if (!customElements.get('ar-shipping-estimate')) customElements.define('ar-shipping-estimate', ShippingEstimate);

  if (script?.dataset.arCartPopupGuard !== 'true') return;
  const root = document.documentElement;
  const cartPage = /(?:^|\/)(?:cart|checkouts?)(?:\/|$)/.test(location.pathname);
  const closed = new WeakSet();
  let drawerOpen = !!document.querySelector('cart-drawer.is-open');
  let intentUntil = 0;
  let intentTimer;
  let protectedContext = false;
  let lastCartFocus;

  const dismissSignup = () => {
    if (!protectedContext) return;
    document.querySelectorAll('[data-kl-scroll-locking-modal]').forEach(modal => {
      if (!modal.querySelector('form.klaviyo-form')) return;
      const close = modal.querySelector('button.klaviyo-close-form');
      if (!close || closed.has(close)) return;
      closed.add(close);
      const hadFocus = modal.contains(document.activeElement);
      // Use Klaviyo's own close handler so it releases focus and scroll locks.
      close.click();
      if (hadFocus && drawerOpen) requestAnimationFrame(() => {
        if (!drawerOpen) return;
        const drawer = document.querySelector('cart-drawer.is-open');
        const target = lastCartFocus?.isConnected && drawer?.contains(lastCartFocus)
          ? lastCartFocus : drawer?.querySelector('[data-cart-drawer-close]');
        target?.focus({preventScroll: true});
      });
    });
  };
  const observer = new MutationObserver(dismissSignup);
  const sync = () => {
    const next = cartPage || drawerOpen || Date.now() < intentUntil;
    root.classList.toggle('ar-cart-focus', next);
    if (next && !protectedContext) observer.observe(document.body, {childList: true, subtree: true});
    if (!next && protectedContext) observer.disconnect();
    protectedContext = next;
    dismissSignup();
  };
  const protectIntent = (duration) => {
    intentUntil = Date.now() + duration;
    clearTimeout(intentTimer);
    intentTimer = setTimeout(sync, duration + 10);
    sync();
  };
  document.addEventListener('theme:cart-drawer:open', () => { drawerOpen = true; sync(); });
  document.addEventListener('theme:cart-drawer:close', () => { drawerOpen = false; sync(); });
  document.addEventListener('focusin', event => {
    if (event.target instanceof Element && event.target.closest('cart-drawer')) lastCartFocus = event.target;
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[name="checkout"], a[href="/checkout"], .shopify-payment-button')) protectIntent(30000);
    else if (event.target.closest('[data-add-to-cart], [data-cart-toggle]')) protectIntent(5000);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target instanceof Element && event.target.matches('[data-cart-form]')) protectIntent(30000);
  }, true);
  window.addEventListener('klaviyoForms', dismissSignup);
  window.addEventListener('pageshow', () => {
    intentUntil = 0;
    drawerOpen = !!document.querySelector('cart-drawer.is-open');
    sync();
  });
  sync();
})();
